import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  sectionTitle: (props) => ({
    padding: theme.spacing(1),
    backgroundColor: props?.sectionColor,
    display: 'inline-block',
    '& .MuiTypography-root': {
      fontFamily: props?.isWebinarPlus ? theme.typography.fontFamily : 'Libre Franklin, serif',
      fontWeight: props?.isWebinarPlus ? 700 : 600,
      color: props?.isWebinarPlus ? '#FFFFFF' : '#1A1A1F',
    },
  }),
}));
